import { t } from 'i18next';
import { useState } from 'react';

import { TableItem } from '../../../styledComponents/ProjectsNew';
import {
  CommonFlex,
  CommonText,
  Container,
  TableText,
} from '../../../styledComponents/common';
import { OfficeItemsTable } from '../officesStyles';

const ItemsRelatedToCampsSectionDisplay = ({ items }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <CommonFlex justifyContent="space-between">
        <CommonText name title fontSize="16px">
          {t('items_related_to_this_camp')}
        </CommonText>
      </CommonFlex>
      <Container
        style={{
          overflow: 'hidden',
        }}
      >
        <OfficeItemsTable heading>
          <TableItem>
            <TableText>{t('item_name')}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{t('quantity_required')}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{t('receipt')}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{t('decreased')}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{t('current_quantity')}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{t('remaining')}</TableText>
          </TableItem>
        </OfficeItemsTable>
        {items.map((item, index) => (
          <OfficeItemsTable key={index}>
            <TableItem>
              <TableText>{item.item_name}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{item.allotted_quantity}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{item.received_quantity}</TableText>
            </TableItem>
            <TableItem>
              <TableText color={item.decreased_quantity < 0 && 'red'}>
                {item.decreased_quantity}
              </TableText>
            </TableItem>
            <TableItem>
              <TableText
              // color={
              //   item.current_quantity < item.allotted_quantity
              //     ? '#f7e033'
              //     : item.current_quantity > item.allotted_quantity
              //     ? 'green'
              //     : 'blue'
              // }
              >
                {item.current_quantity}
              </TableText>
            </TableItem>
            <TableItem>
              <TableText
                color={
                  item.remaining < 0
                    ? 'red'
                    : item.remaining > 0
                    ? 'green'
                    : 'blue'
                }
              >
                {item.remaining > 0 && '+'}
                {item.remaining}
              </TableText>
            </TableItem>
          </OfficeItemsTable>
        ))}
      </Container>
    </div>
  );
};

export default ItemsRelatedToCampsSectionDisplay;
